module.exports = __webpack_public_path__ + "static/media/t-webchat.cada2c9b.svg";